import { render, staticRenderFns } from "./bannerComponent.vue?vue&type=template&id=6bfe8aff&scoped=true&"
import script from "./bannerComponent.vue?vue&type=script&lang=js&"
export * from "./bannerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe8aff",
  null
  
)

export default component.exports